import React from 'react'

import { AlertWithActions, AlertWithActionsProps, AlertWithActionsType } from '@masfront/common-b2c'

import { Tooltip, makeStyles, createStyles, Theme, Box, Card, Typography } from '@material-ui/core'
import LoadIcon from '@material-ui/icons/Cached'
import SuccessIcon from '@material-ui/icons/CheckCircle'
import WarningIcon from '@material-ui/icons/Error'
import InfoIcon from '@material-ui/icons/Info'
import ErrorIcon from '@material-ui/icons/Warning'
import { Color } from '@material-ui/lab'

export interface ItemStatusProps extends AlertWithActionsProps {
  tooltipMessage?: string
}

const icons = {
  info: <InfoIcon />,
  success: <SuccessIcon />,
  error: <ErrorIcon />,
  warning: <WarningIcon />,
  loading: <LoadIcon />,
}

const useStyles = makeStyles(({ palette, spacing }: Theme) => {
  return createStyles({
    alert: {
      boxShadow: 'none',
      backgroundColor: 'inherit',

      '& .MuiAlert-icon': {
        backgroundColor: 'inherit',
        color: ({ type }: ItemStatusProps) =>
          type !== AlertWithActionsType.loading
            ? palette[type as Color].main
            : palette.text.secondary,
        padding: 0,
        marginRight: spacing(2),
      },

      '& .MuiAlert-message': {
        color: ({ type }: ItemStatusProps) =>
          type !== AlertWithActionsType.loading
            ? palette[type as Color].main
            : palette.text.secondary,
        fontWeight: 'bold',
        padding: 0,
        textTransform: 'uppercase',
        marginRight: 0,
      },
    },
    tooltip: {
      backgroundColor: '#fff',
    },
  })
})

export default function ItemStatus({
  type,
  text,
  actions,
  className,
  tooltipMessage,
}: ItemStatusProps) {
  const { alert, tooltip } = useStyles({ type } as ItemStatusProps)
  return (
    <>
      {tooltipMessage ? (
        <Tooltip
          title={
            <Card elevation={5}>
              <Box p={6}>
                <Typography variant="body1">{tooltipMessage}</Typography>
              </Box>
            </Card>
          }
          placement="right"
          classes={{ tooltip }}
        >
          <Box display="inline-flex">
            <AlertWithActions
              type={type}
              icon={icons[type || 'loading']}
              className={className || alert}
              text={text}
              actions={actions}
            />
          </Box>
        </Tooltip>
      ) : (
        <AlertWithActions
          type={type}
          icon={icons[type || 'loading']}
          className={className || alert}
          data-text={text}
          text={text}
          actions={actions}
        />
      )}
    </>
  )
}
